import React from 'react';


const PublicContact = () => {
  return (
    
<div>
<h1>Contacts</h1>
<ul>
    <li><a href="https://www.crazygames.com/game/tank-off">The Game</a></li>
    <li><a href="https://discord.gg/wK6HHMD3">The Discord Server (#tank-off-classic)</a></li>
    <li>Moderator: <a href="mailto:martiangamessupport@111george.com">Sasafrass/Jo/jjaquinta</a>, discord:<br/>
        Deputies:
        <ul>
            <li>TankOff Classic, FeurHund 6909 discord: FeurHund 6909#8896</li>
            <li>TankOff 2, Nightmᥲrᥱ™ discord: nightmareto2</li>
            <li>Kart Wars 2, Superstar discord: taken_boi</li>
        </ul>
    </li>
</ul>
</div>
  );
};


export default PublicContact;
